export default "__VITE_ASSET__e29c0fe5__"